export default __webpack_public_path__ + "static/media/uploader-ascensiaContourNextMeter-problem-2.55457925.png";